<div role="alert" class="alert alert-{{type}} alert-dismissible">
	<i class="{{ icon }}"></i> <ng-content />
	<button type="button" data-bs-dismiss="alert" aria-label="Close" class="btn-close"></button>
</div>
